import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const STRIP_SVG = 'https://cdn.magicpatterns.com/uploads/kDELpqBoq6nNKgQziVuQGT/strip-1000x200.svg';
// Stejná barva jako záhlaví (navy-deep)
const NAVY_DEEP = '#1d3a6b';
export function SailingTracker() {
  const [svgMarkup, setSvgMarkup] = useState<string | null>(null);

  // Načte grafiku a přebarví její pozadí na barvu záhlaví,
  // aby na pruhu nevznikl obdélník v jiném odstínu modré.
  useEffect(() => {
    let cancelled = false;
    fetch(STRIP_SVG).then(res => res.ok ? res.text() : Promise.reject()).then(text => {
      if (cancelled) return;
      const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
      const svg = doc.querySelector('svg');
      if (!svg) return;
      const background = svg.querySelector('rect, path, polygon');
      if (background) {
        background.setAttribute('fill', NAVY_DEEP);
        (background as SVGElement).style.fill = NAVY_DEEP;
      }
      svg.setAttribute('width', '100%');
      svg.removeAttribute('height');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'Sailing Tracker – aplikace pro řízení regaty');
      svg.style.display = 'block';
      setSvgMarkup(new XMLSerializer().serializeToString(svg));
    }).catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return <section aria-labelledby="sailing-tracker-heading" className="w-full bg-navy-deep overflow-hidden" data-id="element-277" data-mp="1kdx3vfo6cc21">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-6xl mx-auto px-6 pt-10 flex flex-col items-center" data-id="element-278" data-mp="1gfhdd1svwljv">
        <div className="text-center" data-id="element-279" data-mp="2440ix9kjuk89">
          <h2 id="sailing-tracker-heading" className="text-white text-xl md:text-2xl font-semibold mb-1" data-id="element-280" data-mp="1zc91ppna9qus">
            Vlastní aplikace pro řízení regaty
          </h2>
          <p className="text-white/75 text-sm md:text-base leading-relaxed" data-id="element-281" data-mp="2n719agtfr4p7">
            Starty, pokyny rozhodčího i průběžné výsledky máte v reálném čase
            přímo v mobilu.
          </p>
        </div>
        {/* Grafika sedí přímo na spodní hraně pruhu – ostrůvek je oříznutý hranicí */}
        <div className="w-full max-w-[1000px] aspect-[5/1] -mb-px" data-id="element-282" data-mp="1zhzvee1u31cj">
          {svgMarkup ? <div className="w-full h-full" dangerouslySetInnerHTML={{
          __html: svgMarkup
        }} data-id="element-283" data-mp="24gjkuofmyv9n" /> : <img src={STRIP_SVG} alt="Sailing Tracker – aplikace pro řízení regaty" width="1000" height="200" className="block w-full h-auto" data-id="element-284" data-mp="1qimlxldpmcrt" />}
        </div>
      </motion.div>
    </section>;
}